const genderTranslate: Record<string, string> = {
  'GENDER.MALE': 'Masculino',
  'GENDER.FEMALE': 'Femenino',
}

export default genderTranslate
